










import Vue, { PropType } from 'vue'
import { deleteClient } from '~/api/Agency/agency.api'
import { Client } from '~/api/Agency/agency.interface'
import IconButton from '~/components/IconButton.vue'
export default Vue.extend({
  components: { IconButton },
  props: {
    item: {
      type: Object as PropType<Client>,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async onClick() {
      this.loading = true
      try {
        await deleteClient(this.item.uuid || '')
        this.$emit('refresh')
      } finally {
        this.loading = false
      }
    },
  },
})
